export default __webpack_public_path__ + "static/media/yugiohLogo.65283fec.png";